import React from 'react';
import HeaderComponent from '../components/General/HeaderComponent';
import { ProCreateDetailsComponent } from '../components/ProCreateDetailsComponent';

export default function CreateProjectDetails() {
  return (
    <div className="w-full dark:bg-dark-100 bg-stone-100 min-h-screen">
      <div className="container mx-auto">
        <HeaderComponent title="Proje Detayları" />
        <div className="mt-8">
          <ProCreateDetailsComponent />
        </div>
      </div>
    </div>
  );
}
